import { Box } from "@otrium/core";
import styled from "@emotion/styled";
import { OutsideClickableBox } from "src/atoms/OutsideClickableBox";
import { scrollbar } from "src/scrollbar";

const OutsideClickableWrapper = styled(OutsideClickableBox)`
  display: flex;
  flex-direction: column;
  max-height: inherit;
`;

// NOTE: We need to have here position: relative; because Google Chrome hides inner content of this component
// https://stackoverflow.com/questions/22898335/strange-behavior-of-overflow-auto-on-chrome
const ScrollWrapper = styled(Box)`
  position: relative;
  overflow: auto;
  margin-bottom: ${({ theme }) => theme.space[3]}px;
  max-height: inherit;
  flex-grow: 1;
  overscroll-behavior: contain;

  ${scrollbar}
`;

const FilterContentWrapper = styled(Box)<{
  isMultiColumn?: boolean;
  count?: number;
}>`
  display: grid;
  gap: ${({ theme }) => theme.space.space8};
  ${({ isMultiColumn, count }) =>
    isMultiColumn &&
    `
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-template-rows: repeat(${count || 1}, auto);
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    row-gap: ${({ theme }) => theme.space.space24};

    > div > div > label {
      display: flex;
      flex-direction: row;
    }
  }
`;

export { OutsideClickableWrapper, FilterContentWrapper, ScrollWrapper };
